import { Module, StatusPanelDef } from '@ag-grid-community/core'
import { EnterpriseCoreModule } from '@ag-grid-enterprise/core'
import { StatusBarModule } from '@ag-grid-enterprise/status-bar'
import { SelectedRowsStatusBarComp } from '@helios/generic-components'
import {
  WorkbenchAmountStatusBarComp,
  WorkbenchMarginStatusBarComp,
} from './workbench-money-status-bar'
import { WorkbenchRangeSumStatusBarComp } from './workbench-range-sum-status-bar'
import { WorkbenchRowsStatusBarComp } from './workbench-rows-status-bar'
import { WorkbenchUnitsStatusBarComp } from './workbench-units-status-bar'

export const workbenchStatusBarModuleName = 'hsWorkbenchStatusBarModule'
export const workbenchRowsStatusBar = 'hsWorkbenchRowsStatusBar'
export const workbenchSelectedRowsStatusBar = 'hsWorkbenchSelectedRowsStatusBar'
export const workbenchUnitsStatusBar = 'hsWorkbenchUnitsStatusBar'
export const workbenchMarginStatusBar = 'hsWorkbenchMarginStatusBar'
export const workbenchAmountStatusBar = 'hsWorkbenchAmountStatusBar'
export const workbenchRangeSumStatusBar = 'hsWorkbenchRangeSumStatusBar'

/**
 * The workbench status bar: counts on the left, selection totals on the right. Panel order matches
 * the classic Clearwater grid (units, margin, amount) so both panels scan the same way. Every
 * summary panel collapses when it has nothing to report, which is how source-specific panels
 * (margin, range sum) stay out of the way without being reconfigured on a source swap.
 */
export const workbenchStatusBarPanel: { statusPanels: StatusPanelDef[] } = {
  statusPanels: [
    {
      statusPanel: workbenchRowsStatusBar,
      align: 'left',
    },
    {
      statusPanel: workbenchSelectedRowsStatusBar,
      align: 'left',
    },
    {
      statusPanel: workbenchUnitsStatusBar,
      align: 'right',
    },
    {
      statusPanel: workbenchMarginStatusBar,
      align: 'right',
    },
    {
      statusPanel: workbenchAmountStatusBar,
      align: 'right',
    },
    {
      statusPanel: workbenchRangeSumStatusBar,
      align: 'right',
    },
  ],
}

export const WorkbenchStatusBarModule: Module = {
  moduleName: workbenchStatusBarModuleName,
  userComponents: [
    {
      componentName: workbenchRowsStatusBar,
      componentClass: WorkbenchRowsStatusBarComp,
    },
    {
      // Reused verbatim from Transactions 1.0 so `Selected: n` is the same component, not a lookalike.
      componentName: workbenchSelectedRowsStatusBar,
      componentClass: SelectedRowsStatusBarComp,
    },
    {
      componentName: workbenchUnitsStatusBar,
      componentClass: WorkbenchUnitsStatusBarComp,
    },
    {
      componentName: workbenchMarginStatusBar,
      componentClass: WorkbenchMarginStatusBarComp,
    },
    {
      componentName: workbenchAmountStatusBar,
      componentClass: WorkbenchAmountStatusBarComp,
    },
    {
      componentName: workbenchRangeSumStatusBar,
      componentClass: WorkbenchRangeSumStatusBarComp,
    },
  ],
  dependantModules: [StatusBarModule, EnterpriseCoreModule],
}
